import { Fragment, h } from 'preact'; /** @jsx h */

const isValid = event => {
    const target = event.target;
    if (!target.checkValidity()) {
        target.classList.add('isInvalid');
    } else if (target.classList && target.classList.contains('isInvalid')) {
        target.classList.remove('isInvalid');
    }
};

const validationTxt = (inProps, language) => {
    const isEnglish = language === 'en';

    if (inProps.required && !inProps.value && inProps.value !== 0) {
        return isEnglish ? 'Required field' : 'Obligatorisk felt';
    } else if (inProps.minLength && (inProps.value || '').length < inProps.minLength) {
        return isEnglish
            ? `The message must have a minimum of ${inProps.minLength} characters`
            : `Feltet krever minimum ${inProps.minLength} tegn`;
    } else if (inProps.maxLength && (inProps.value || '').length > inProps.maxLength) {
        return isEnglish
            ? `The message can't be more then ${inProps.maxLength} characters. Now it's ${inProps.value.length} characters.`
            : `Feltet kan ikke inneholde mer enn ${inProps.maxLength} tegn. Nå: ${inProps.value.length} tegn.`;
    } else if (inProps.apiError) {
        return inProps.apiError;
    }

    return inProps.invalidTxt || (isEnglish ? 'Invalid input' : 'Ugyldig input');
};

export const InputOptionsMyPage = props => {
    const { label, value, name, options, className, isFullW, onChange } = props;

    if (options) {
        return (
            <label className={`checkbx check-no-label ${className || ''}`}>
                <span>{label}:</span>
                <select
                    className={isFullW ? 'full-width' : ''}
                    value={value}
                    name={name || label}
                    onChange={onChange}
                >
                    {options.map(opt => {
                        return (
                            <option {...opt} key={opt.value} value={opt.value}>
                                {opt.txt}
                            </option>
                        );
                    })}
                </select>
            </label>
        );
    } else {
        return <Fragment></Fragment>;
    }
};

export const InputField = props => {
    const {
        value,
        name,
        required,
        setVal,
        setOnBlur,
        lbl,
        type,
        placeholder,
        addClasses,
        style,
        hidden,
        infoTxt,
        language,
        inputRef
    } = props;

    const onBlur = e => {
        if (setOnBlur) setOnBlur(e);
        isValid(e);
    };
    const setType = () => type || 'text';

    return (
        <label
            className={`${addClasses || ''} labelWrapper${hidden ? ' hidden' : ''}`}
            style={style}
        >
            <input
                className={(value || value === 0) && 'hasVal'}
                type={setType}
                name={name || 'unknownField'}
                placeholder={placeholder}
                onInput={setVal}
                {...props}
                onBlur={e => onBlur(e)}
                data-error={props.apiError}
                ref={inputRef}
                data-matomo-mask
            />
            <span className="labeltxt">
                {lbl || ''} {required && '*'}
            </span>
            <p className="invalidText" aria-live="polite">
                {lbl || ''}: {validationTxt(props, language)}
            </p>
            {infoTxt && <p className="infotext">{infoTxt}</p>}
        </label>
    );
};
export const TextArea = props => {
    const { value, setVal, name, lbl, required, infoTxt, language, showCounter, textareaRef } =
        props;

    const textAreaComponent = (
        <textarea
            name={name || 'unknownField'}
            onInput={setVal}
            value={value}
            onBlur={e => isValid(e)}
            ref={textareaRef}
            {...props}
        />
    );

    return (
        <div className="textarea-wrapper">
            <label htmlFor={name}>
                {lbl || ''} {required && '*'}
            </label>
            {showCounter ? (
                <div className="textarea-counter">
                    {textAreaComponent}
                    <p className="textarea-counter-p">{`${value.length}/${props.maxLength}`}</p>
                </div>
            ) : (
                <>
                    {textAreaComponent}
                    <p className="invalidText">{validationTxt(props, language)}</p>
                </>
            )}
            {infoTxt && <p className="infotext">{infoTxt}</p>}
        </div>
    );
};

export const NumberInput = props => {
    return (
        <InputField
            type="number"
            value={props && props.value ? props.value : '1'}
            invalidTxt={`Felt må inneholde tall
                        ${props.min && props.max ? ` mellom ${props.min} og ${props.max}` : ''}
                        ${props.min && !props.max ? ` over ${props.min}` : ''}
                        ${props.max && !props.min ? ` under ${props.max}` : ''}
                        .`}
            {...props}
        />
    );
};
export const TextInput = props => {
    return <InputField type="text" value={props.value} {...props} />;
};
export const Email = props => {
    return (
        <InputField
            lbl="E-post"
            type="email"
            name="ho_epost"
            pattern="^[^\s@]+@[^\s@]+\.[^\s@]+$"
            {...props}
            invalidTxt={`Ugyldig e-post.${
                (props.value || '').indexOf('@') < 0 ? ' Mangler @ i adresse.' : ''
            }${
                (props.value || '').indexOf('.') < 0 ? ' Mangler punktum før domene' : ''
            }. Eks: Kari@epost.domene`}
        />
    );
};
export const Mobile = props => {
    return (
        <InputField
            lbl={`${props.lbl || 'Mobilnummer'}`}
            type="tel"
            name="ho_mobilnr"
            pattern="[0-9]{8,12}"
            {...props}
            invalidTxt={`Ugyldig telefonnummer.${
                /^\d+$/.test(props.value) ? '' : ' Skal kun inneholde tall.'
            }${(props.value || '').indexOf('+') >= 0 ? ' Erstatt + med 00 og prøv igjen.' : ''}${
                /^\d+$/.test(props.value) && props.value.length < 8
                    ? ' Må være minimum 8 tall.'
                    : ''
            }${
                /^\d+$/.test(props.value) && props.value.length > 12 ? ' Må være maks 12 tall.' : ''
            }`}
        />
    );
};
export const FirstName = props => {
    return (
        <InputField
            lbl="Fornavn"
            name="ho_fnavn"
            value={props && props.value ? props.value : ''}
            {...props}
        />
    );
};
export const LastName = props => {
    return (
        <InputField
            lbl="Etternavn"
            name="ho_enavn"
            value={props && props.value ? props.value : ''}
            {...props}
        />
    );
};
export const newSelected = (array, indSelected) => {
    const rList = [];
    array.forEach((item, ind) => {
        rList.push({ ...item, selected: indSelected === ind });
    });
    return rList;
};
export const mapOptions = (options, name, setVal, changeInfo) => {
    if (options && options.length > 0) {
        const indLength = 100 / options.length;
        return (
            <Fragment>
                {options.map((option, ind) => (
                    <label
                        key={option.lbl}
                        className={`optionBtn labelWrapper ${option.selected && 'isSelected'}`}
                        style={{ width: `${indLength}%` }}
                    >
                        <input
                            className={option.value && 'hasVal'}
                            type="radio"
                            value={option.value}
                            name={name}
                            onChange={() => setVal(changeInfo, newSelected(options, ind))}
                            checked={option.selected}
                            {...option}
                        />
                        <span className="labeltxt">{option.lbl || ''}</span>
                    </label>
                ))}
            </Fragment>
        );
    }
};

const getMonthTxt = inDate => ('0' + (inDate.getMonth() + 1).toString()).slice(-2);
const getDate = inDate => ('0' + inDate.getDate().toString()).slice(-2);
export const ddMmYyyyVal = inDate => {
    const regex = /^\d{4}\.\d{2}\.\d{2}$/;
    const regex2 = /^\d{4}-\d{2}-\d{2}$/;

    if (inDate instanceof Date) {
        return `${getDate(inDate)}.${getMonthTxt(inDate)}.${inDate.getFullYear()}`;
    } else if (typeof inDate === 'string' && regex.test(inDate)) {
        const yyMmDd = inDate.split('.'); // should be year, month, day
        if (yyMmDd.length > 2) {
            return `${yyMmDd[2]}.${yyMmDd[1]}.${yyMmDd[0]}`;
        }
    } else if (typeof inDate === 'string' && regex2.test(inDate)) {
        const yyMmDd = inDate.split('-'); // should be year, month, day
        if (yyMmDd.length > 2) {
            return `${yyMmDd[2]}.${yyMmDd[1]}.${yyMmDd[0]}`;
        }
    }

    return inDate;
};
export const yyyyMmDdVal = inDate => {
    if (inDate instanceof Date) {
        return `${inDate.getFullYear()}-${getMonthTxt(inDate)}-${getDate(inDate)}`;
    } else {
        return inDate;
    }
};
const dateInPast = inDate => {
    let dDate = inDate;
    const today = new Date();
    if (typeof inDate === 'string') {
        dDate = new Date(dDate);
    }
    if (dDate.setHours(0, 0, 0, 0) <= today.setHours(0, 0, 0, 0)) {
        return true;
    }
    return false;
};

export const DateField = props => {
    const formattedValue = props.value ? ddMmYyyyVal(props.value) : '';
    const before = props.value ? dateInPast(props.value) : false;
    return (
        <>
            <InputField
                {...props}
                type="date"
                name={`view-${props.name}`}
                style={{ maxWidth: 400 }}
                invalidTxt={
                    before
                        ? 'Du har valgt en dato tilbake i tid. Velg dato tidligst i dag.'
                        : 'Vennligst skriv dato i format: år-måned-dag (YYYY-MM-DD)'
                }
            />
            <HiddenInput name={props.name} value={formattedValue} />
        </>
    );
};

export const RadioButtons = props => {
    // TODO: define options as array of objects
    const { options, name, setVal, changeInfo } = props;
    return (
        <fieldset className="radioButtons">
            <legend>Hvordan vil du betale ditt bidrag?</legend>
            <div className="flex-wrapper">{mapOptions(options, name, setVal, changeInfo)}</div>
        </fieldset>
    );
};

const paymentHelpText = {
    avtalegiro: 'Du blir sendt videre til Nets for å signere AvtaleGiroen med BankID',
    vipps: 'Du blir sendt videre til Vipps-appen',
    visa: 'Du blir sendt videre til Nets for å fullføre betalingen',
    mastercard: 'Du blir sendt videre til Nets for å fullføre betalingen'
};

export const mapPaymentOptions = (options, name, setVal, changeInfo, formId) => {
    if (options && options.length > 0) {
        return (
            <Fragment>
                {options.map((option, ind) => {
                    const { value, lbl, selected } = option;
                    const radioButtonId = `radio-${formId}-${value}`;
                    const helpText = paymentHelpText[value];

                    return (
                        <div className={`paymentRadioButtonRow ${value}`} key={lbl}>
                            <input
                                className="customRadioButton"
                                type="radio"
                                value={value}
                                name={name}
                                onChange={() => setVal(changeInfo, newSelected(options, ind))}
                                checked={selected}
                                id={radioButtonId}
                                {...option}
                            />
                            <label className="customRadioButtonLabel" htmlFor={radioButtonId}>
                                <span className="customRadioButtonLabelSpan">{lbl || ''}</span>
                                {helpText && <span className="paymentHelpText">{helpText}</span>}
                            </label>
                        </div>
                    );
                })}
            </Fragment>
        );
    }
};

export const PaymentRadioButtons = props => {
    // TODO: define options as array of objects
    const { options, name, setVal, changeInfo, formId } = props;
    return (
        <fieldset className="paymentRadioButtons">
            <div>{mapPaymentOptions(options, name, setVal, changeInfo, formId)}</div>
        </fieldset>
    );
};

export const changeDefault = (event, array) => {
    const rList = [];
    array.forEach(item => {
        rList.push({ ...item, isDefault: event.target.value === item.value });
    });
    return rList;
};
export const FreeTextOption = props => {
    const { options, setVal } = props;
    return (
        <>
            <InputField
                type="text"
                list={`${props.id || 'optionsList'}List`}
                setVal={setVal}
                {...props}
                addClasses="option-txt"
            />
            <datalist id={`${props.id || 'optionsList'}List`} key="optionsList">
                {options &&
                    options.length > 0 &&
                    options.map(opt => {
                        let { value, label } = opt;
                        if (
                            !label ||
                            value.toString() === label.substring(0, label.lastIndexOf(' '))
                        )
                            label = '';
                        return <option key={value} value={value} label={label} />;
                    })}
            </datalist>
        </>
    );
};
export const OptionsList = ({
    id,
    label,
    options,
    onChange,
    selected,
    name,
    addClasses,
    spanAfter
}) => {
    const selId = id || 'selId';

    return (
        <label htmlFor={selId} className={`option-list ${addClasses || ''}`}>
            {!spanAfter && <span>{label || ''}</span>}

            <select id={selId} value={selected} onChange={onChange} name={name}>
                {options &&
                    options.length > 0 &&
                    options.map(({ value, label, isDisabled }) => {
                        return (
                            <option key={value} value={value} disabled={isDisabled}>
                                {label || ''}
                            </option>
                        );
                    })}
            </select>
            {spanAfter && <span className="labeltxt">{label || ''}</span>}
        </label>
    );
};
export const SubmitBtn = props => {
    return (
        <button type="submit" className={`submitBtn ${props.classes || ''}`} {...props}>
            {props.txt || 'Send inn'}
        </button>
    );
};
export const HiddenInput = ({ name, value }) => {
    return <input type="hidden" value={value} name={name} />;
};

export const CheckBox = ({ name, checked, label, onChange, infoTxt, addClasses }) => {
    return (
        <label className={`checkBoxLbl labelWrapper ${addClasses || ''}`}>
            <input type="checkbox" name={name} value="J" checked={checked} onChange={onChange} />
            <span>{label || ''}</span>
            {infoTxt && <p className="infotext">{infoTxt}</p>}
        </label>
    );
};
